import { createContext, useContext } from 'react';

export const PermitIssueContext = createContext<{
  pageId: string;
}>({
  pageId: ''
});

export const usePermitIssue = () => useContext(PermitIssueContext);
